import moment from 'moment';
import { TypeFilterValue, TypeSingleFilterValue, TypeSortInfo } from '@inovua/reactdatagrid-enterprise/types';
import { getUtcOffset } from 'utils/helpers';

export const mapSortInfo = (sortInfo?: TypeSortInfo) => {
  if (!sortInfo) {
    return undefined;
  }
  if (Array.isArray(sortInfo)) {
    return sortInfo.map((sort) => ({ [sort.name]: sort.dir }));
  }
  return { [sortInfo.name]: sortInfo.dir };
};

const mapFilter = ({ operator, value, type }: TypeSingleFilterValue) => {
  const offset = getUtcOffset() ?? 0;

  switch (operator) {
    case 'inrange':
      return Object.entries(value).reduce((acc, [key, val]) => {
        if (!val) return acc;

        const isGreaterThan = key === 'start';
        return {
          ...acc,
          [isGreaterThan ? 'gte' : 'lte']:
            type === 'date'
              ? moment(val as string, 'YYYY/MM/DD')
                  .subtract(offset, 'hours')
                  .add(!isGreaterThan ? 1 : 0, 'days')
                  .toDate()
              : val,
        };
      }, {});
    case 'eq':
      return type === 'date'
        ? {
            gte: moment(value, 'YYYY/MM/DD').subtract(offset, 'hours').toDate(),
            lt: moment(value, 'YYYY/MM/DD').subtract(offset, 'hours').add(1, 'days').toDate(),
          }
        : value;
    case 'gt':
    case 'gte':
    case 'lt':
    case 'lte':
      return { [operator]: value };
    default:
      return value;
  }
};

export const mapFilterBy = (filterBy?: TypeFilterValue) => {
  if (filterBy?.length === 0) return undefined;

  return filterBy?.reduce((acc: Record<string, string>, filter: TypeSingleFilterValue) => {
    if (!filter.value || filter.value.length === 0) return acc;
    const value = mapFilter(filter);
    if (typeof value === 'object' && Object.keys(value).length === 0 && !(value instanceof Date)) {
      return acc;
    }
    return { ...acc, [filter.name]: value };
  }, {});
};
